// LOBBY (§4.7): non-scoring free play; a bean that falls parachutes back in after
// `TUNE.respawn.lobbyTicks`. The round never ends (the room leaves the Lobby on its own).
import { TUNE } from '../constants';
import { ModeId } from '../ids';
import { tickRespawns } from './common';
import type { ModeRules } from './modeTypes';

export const LOBBY_MODE: ModeRules = {
  id: ModeId.LOBBY,
  name: 'Lobby',
  minBeans: 1,
  respawns: true,
  ghosts: false,
  init() {},
  onTick(w, _clock, predict) {
    tickRespawns(w, predict);
  },
  onKO(w, victim) {
    w.beans[victim].respawnTicks = TUNE.respawn.lobbyTicks;
  },
  onHit() {},
  onTouch() {},
  speedMult() {
    return 1;
  },
  itemsBlocked() {
    return false;
  },
  results() {
    return [];
  },
};
